import React from "react";
import styled from "styled-components";
import Board from "../Board/Board";

interface MobilePageCoverProps {
  header?: React.ReactNode;
  children: React.ReactNode;
}

const MobilePageCover = ({ header, children }: MobilePageCoverProps) => {
  return (
    <MobilePageCoverLayout>
      <NavigationHeader>{header}</NavigationHeader>
      <Content>{children}</Content>
    </MobilePageCoverLayout>
  );
};

export default MobilePageCover;

const MobilePageCoverLayout = styled.div`
  display: flex;
  flex-direction: column;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

const NavigationHeader = styled.div`
  position: sticky;
  top: 0;
  padding: 1.2rem 1.6rem;
  background-color: ${({ theme }) => theme.color.white};
  width: 100%;
`;

const Content = styled(Board)`
  flex: 1;
  border-radius: 0;
`;
